import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'productSort', standalone: true })
export class ProductSortPipe implements PipeTransform {
  transform(items: any[], field: string, reverse: boolean = false): any[] {
    if (!items) {
      return [];
    }
    if (field === 'name' || field === 'Name') {
      items.sort((a, b) => (a[field] > b[field] ? 1 : -1));
    } else {
      items.sort((a, b) => (Number(a[field]) > Number(b[field]) ? 1 : -1));
    }
    if (reverse) {
      items.reverse();
    }

    return items;
  }
}
